import { call, put, select, takeEvery } from 'redux-saga/effects';
import { FetchService, putToS3WithProgress, showDialog } from '@/utils';
import { authSelector } from '../selectors';
import { GET_SIGNED_URL, GET_UPLOAD_SIGNED_URL, SIMPLE_S3_DONE, SIMPLE_S3_FAILED, SIMPLE_S3_PROGRESS, START_SIMPLE_S3_UPLOAD } from './action-types';
import { verifyFile } from '@/utils/FetchFileService';

function* getSignedUploadUrlAsync({ payload, callback }: any): any {
  try {
    const { user } = yield select(authSelector);
    const { result } = yield call(FetchService, 'file/upload', 'POST', payload, user?.token);
    if (result) {
      if (callback) callback({ ok: true, value: result });
    }
  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showDialog, message, 'error');
  }
}
function* getSignedUrlAsync({ payload, callback }: any): any {
  try {
    const { user } = yield select(authSelector);
    const { result } = yield call(FetchService, 'file', 'POST', payload, user?.token, false);
    if (result) {
      if (callback) callback({ ok: true, value: result });
    }
  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showDialog, message, 'error');
  }
}
function* simpleS3UploadWorker({ payload }: any): Generator<any, void, any> {
  try {
    const { file, folder } = payload;
    if (!file) throw new Error('No file provided');

    const { user } = yield select(authSelector);
    const token = user?.token;

    // 1) Get pre-signed URL from your EXISTING API (use whichever you already have)
    // Example A: file/upload (returns { url, key, contentType? })
    const signRes: any = yield call(
      FetchService,
      'file/upload',
      'POST',
      {
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        folder, // optional if your API supports it
      },
      token
    );

    const { url, key } = signRes?.result || {};
    if (!url || !key) throw new Error('Signed URL or key missing from backend');

    // 2) PUT to S3 with progress
    yield call(putToS3WithProgress, url, file, (percent) => {
      // dispatch progress ticks as they happen
      // (tiny trick: progress > 99 stays at 99 until we verify)
      const safePct = Math.min(percent, 99);
      window.requestAnimationFrame?.(() =>
        (window as any).store?.dispatch?.({ type: SIMPLE_S3_PROGRESS, payload: { percent: safePct } })
      );
    });

    // 3) Optionally verify using your existing helper
    try {
      const ok: boolean = yield call(verifyFile, key, token);
      if (!ok) console.warn('verifyFile returned false; file may still be eventually consistent');
    } catch (_) {
      // Non-fatal
    }

    // 4) Done
    yield put({ type: SIMPLE_S3_PROGRESS, payload: { percent: 100 } });
    yield put({ type: SIMPLE_S3_DONE, payload: { key } });
  } catch (error: any) {
    const message = error?.message || 'Upload failed';
    yield put({ type: SIMPLE_S3_FAILED, error: message });
    yield call(showDialog, message, 'error');
  }
}

export function* watchSimpleS3Upload() {
  yield takeEvery(START_SIMPLE_S3_UPLOAD, simpleS3UploadWorker);
}
export function* watchGetUploadSignedUrl() {
  yield takeEvery(GET_UPLOAD_SIGNED_URL, getSignedUploadUrlAsync);
}

export function* watchGetSignedUrl() {
  yield takeEvery(GET_SIGNED_URL, getSignedUrlAsync);
}
